import React from "react"

const variants: {
  [key:string]: any
} = {
  "large-header": {
    defaultElement: "div",
    typography: "font-poppins font-extrabold leading-[138%] text-[36px] md:text-[42px]"
  },
  "small-subheader": {
    defaultElement: "div",
    typography: "font-poppins font-extrabold leading-[138%] text-[18px]"
  },
  "large-subheader": {
    defaultElement: "div",
    typography: "font-poppins font-extrabold leading-[138%] text-[24px]"
  },
  "body": {
    defaultElement: "div",
    typography: "font-martel-sans leading-[180%] text-[18px]"
  },
  "body-caps": {
    defaultElement: "div",
    typography: "font-martel-sans font-semibold leading-[180%] text-[16px] uppercase"
  },
  "display-body": {
    defaultElement: "div",
    typography: "font-martel-sans leading-[220%] text-[28px] md:text-[36px]"
  },
  "caption": {
    defaultElement: "div",
    typography: "font-martel-sans leading-[normal] text-[16px]"
  },
  "small-caption": {
    defaultElement: "div",
    typography: "font-martel-sans leading-[140%] text-[14px]"
  },
  "small-caption-caps": {
    defaultElement: "div",
    typography: "font-martel-sans leading-[140%] text-[14px] uppercase font-semibold"
  },
  "button-text": {
    defaultElement: "div",
    typography: "uppercase font-martel-sans font-semibold leading-[normal] text-[12px] md:text-[16px] tracking-[1.44px]"
  },
  "medium-header": {
    defaultElement: "div",
    typography: "font-poppins font-extrabold leading-[138%] text-[28px] md:text-[32px]"
  },
  "text-link": {
    defaultElement: "div",
    typography: "font-martel-sans text-[16px] underline"
  }
}

interface OwnProps {
  as?: React.ElementType;
  children: string | React.ReactNode;
  variant: string;
}

type TextProps = OwnProps

export const Text: React.FC<TextProps> = ({
  as,
  children,
  variant,
}) => {
  const reactElement = as || variants[variant].defaultElement || "div"
  return React.createElement(
    reactElement,
    { className:  variants[variant].typography},
    children
  )
}
